// extracted by mini-css-extract-plugin
module.exports = {"status":"table_status__39ibf"};